import React, { useState,useEffect } from 'react';
import realtimeDB from "../Utils/api";
import FullCapacity from "../Contents/Lista/FullCapacity";
import LoadingLista from '../Contents/Lista/LoadingLista';
import StatusActivada from '../Contents/Lista/StatusActivada';
import StatusDesactivada from '../Contents/Lista/StatusDesactivada';
import StatusCierre from '../Contents/Lista/StatusCierre';
import StatusLapiz from '../Contents/Lista/StatusLapiz';
import StatusVereda from '../Contents/Lista/StatusVereda';
import styled from "styled-components";

const Page=styled.div`
position: absolute;
top:0;
bottom: 0;
left: 0;
right: 0;
margin: auto;
display:grid;
justify-content:center;
align-content:center;`;


const ImageLogo=styled.img`
margin-bottom: 1.2rem;
justify-self:center;
object-fit:contain;
height:80px;`;

const Text=styled.h1`
margin:0;
justify-self:center;
font-size:24px;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}`;

const Lista=()=>
{
    const [CountWaiting, setCountWaiting] = useState(0);
    const [CountWaitingT_V, setCountWaitingT_V] = useState(0);
    const [Status, setStatus] = useState(undefined);

    const fetchData=()=>
    {
        realtimeDB.ref("/Customers").on("value", snapshot =>
        {
            let countWaiting=0;
            let countWaitingT_V=0;
            snapshot.forEach((customer) =>
            {
                const {status,letter}=customer.val();
                if(status !=="no-info" && status!=="cancelled" && status !=="served")
                {
                    countWaiting++;
                }

                if(letter==="V" || letter==="T" || letter==="TV")
                {
                    countWaitingT_V++;
                }
            });

            setCountWaiting(countWaiting);
            setCountWaitingT_V(countWaitingT_V);
            realtimeDB.ref("/ConfigList").on("value",snapshot =>
            {
                const DateNow=new Date();
                const Hora=DateNow.getHours();
                let status=snapshot.val().Status;
                if(Hora<=18 && Hora>=4)
                {
                    status="DESACTIVADA";
                }
                setStatus(status);
            });
        });
    }

    useEffect(() => 
    {
        window.document.title="Lista de Espera";
        window.document.getElementById("favicon").href="https://i.pinimg.com/originals/b5/cb/ac/b5cbac8fd0f87d2d08b490bdd82b597d.png";
        fetchData();
    }, [])

   if(!Status)
   {
        return(<Page>
        <LoadingLista/>
        </Page>);
   }
   else
   {
    const Logo=<ImageLogo src="https://firebasestorage.googleapis.com/v0/b/waitwhile-app.appspot.com/o/images%2Faccounts%2F3q2SXkB2XwCwg2a914W9%2F62b4db43-63b9-4629-896f-27dc90d46f77.jpg?alt=media&token=4d305a05-e0da-4658-b42b-2ef93f35d975" alt={`Logo de Baum Lanús`}/>;
    

    if(CountWaiting>=20)
    {
         return(<Page>
             <FullCapacity Logo={Logo}/>
         </Page>);
    }
    else
    {
        if(Status==="ACTIVADA")
        {
        return <Page>
            <StatusActivada Logo={Logo}/>
        </Page>
        }

        if(Status==="DESACTIVADA")
        {
        return <Page>
            <StatusDesactivada Logo={Logo}/>
        </Page>
        }

        if(Status==="VEREDA Y TERRAZA")
        {
        return<Page>
            <StatusVereda Logo={Logo} CountWaiting={CountWaitingT_V}/>
        </Page>
        }

        if(Status==="CIERRE")
        {
        return <Page>
            <StatusCierre Logo={Logo}/>
        </Page>
        }

        if(Status==="PAPEL Y LAPIZ")
        {
        return <Page>
            <StatusLapiz Logo={Logo}/>
        </Page>
        }
    }
   }
}

export default Lista;
